/**
 * Models the filtered chart reviews bulk edit
 */

import Brace from "backbone.brace";
import FormModel from "./bulk-edit-form";
import environment from "../../common/environment";

const BulkEditFilteredModel = Brace.Model.extend({
  urlRoot: environment.getEndpoint("chart-reviews:bulk-update-filtered"),

  namedAttributes: {
    data: FormModel,
    filters: Object,
  },

  validate(attrs) {
    if (!attrs.data.isValid()) {
      return attrs.data.validationError;
    }
  },
});

export { BulkEditFilteredModel as default };
